import { auth } from "firebase";
import React, { useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import useInput from "src/Hooks/useInput";
import AuthPresenter from "./AuthPresenter";

interface IProps extends RouteComponentProps<any> {}
const AuthContainer: React.SFC<IProps> = ({ match }) => {
  const [signInForm, setSignInForm] = useState<boolean>(!match.params.username);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const signUpEmail = useInput("");
  const signUpPassword = useInput("");
  const signInEmail = useInput("");
  const signInPassword = useInput("");

  const toggleSignInForm = () => {
    setSignInForm(!signInForm);
  };
  const signIn = () => {
    setIsLoading(true);
    auth()
      .signInWithEmailAndPassword(
        signInEmail.value.replace(" ", ""),
        signInPassword.value
      )
      .catch((e) => {
        setIsLoading(false);
        toast.error(e.message);
      });
  };

  const signUpWithEmail = () => {
    setIsLoading(true);
    auth()
      .createUserWithEmailAndPassword(
        signUpEmail.value.replace(" ", ""),
        signUpPassword.value
      )
      .catch((e) => {
        setIsLoading(false);
        toast.error(e.message);
      });
  };

  const useGoogle = () => {
    let provider = new auth.GoogleAuthProvider();
    setIsLoading(true);
    auth()
      .signInWithPopup(provider)
      .catch((e) => {
        setIsLoading(false);
        toast.error(e.message);
      });
  };
  return (
    <AuthPresenter
      isLoading={isLoading}
      signInForm={signInForm}
      toggleSignInForm={toggleSignInForm}
      signIn={signIn}
      signUpWithEmail={signUpWithEmail}
      useGoogle={useGoogle}
      signUpEmail={signUpEmail}
      signUpPassword={signUpPassword}
      signInEmail={signInEmail}
      signInPassword={signInPassword}
    />
  );
};

export default withRouter(AuthContainer);
